import React from 'react'

/** Helper type for accepting SVG icons from multiple libraries as prop  */
export type SvgIconType = React.ElementType<
  React.RefAttributes<SVGSVGElement>
>

/** Renders an SVG icon in a library-agnostic way (as their standard prop APIs are incompatible between each other) */
export function SvgIcon(props: {
  icon: SvgIconType
  size?: number
  color?: string
  className?: string
} & React.SVGAttributes<SVGElement>) {
  const { icon: Icon, size, color, ...svgProps } = props
  return (
    <Icon
      width={size}
      height={size}
      style={{
        color: color,
        width: size, // MUI fix
        height: size // MUI fix
      }}
      {...svgProps}
    />
  )
}
